
import breadcrumbsMixin from '~/mixins/breadcrumbs/breadcrumbsMixin'
import contractorsMixin from '~/mixins/users/contractorsMixin'
import dictMixin from '~/mixins/dictMixin'
import generalMixin from '~/mixins/generalMixin'

import breadcrumbsLine from '~/components/breadcrumbsLine'
import contractorCard from '~/components/users/contractorCard'
import freelancerFilterCard from '~/components/freelancer/filter-card'

export default {
  components: {
    breadcrumbsLine,
    contractorCard,
    freelancerFilterCard
  },

  mixins: [
    contractorsMixin
  ],

  async asyncData ({ route, $config, $axios, i18n, localePath }) {
    const filter = generalMixin.methods.urlGetParams(!!route.params && !!route.params.filter ? route.params.filter : {})

    const [res, res2] = await Promise.all([
      contractorsMixin.methods.apiContractorsGetList(filter, $axios),
      dictMixin.methods.apiDictGetCountries($axios)
    ])

    const countries_options = []
    if (!!res2?.success) {
      if (!Array.isArray(res2.countries)) {
        res2.countries = Object.entries(res2.countries)
      }
      countries_options.push({ value: null, text: i18n.t('worldwide') })
      countries_options.push({ value: null, text: '', disabled: true })
      res2.countries.forEach((item) => {
        countries_options.push({ value: item.code, text: item.name })
      })
    }

    let breaditems = [
      {
        text: i18n.t('contractors.index.title'),
        disabled: true,
        href: $config.baseUrl + localePath({ name: 'contractors' })
      }
    ]
    breaditems = breadcrumbsMixin.methods.breadcrumbsItems(breaditems, localePath)

    const breadldjson = breadcrumbsMixin.methods.breadcrumbsLdJson(breaditems)

    const data = {
      countries_options,
      items: !!res && !!res.contractors && !!res.contractors.rows ? res.contractors.rows : [],

      currentPage: !!res && !!res.contractors && !!res.contractors.page ? res.contractors.page : 1,
      totalPages: !!res && !!res.contractors && !!res.contractors.pages ? res.contractors.pages : 1,

      perPage: 12,

      breaditems,
      breadldjson
    }

    return data
  },

  head () {
    return {
      title: this.$t('contractors.index.title'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('contractors.index.desc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.$t('contractors.index.desc')
        },
        { hid: 'og:title', name: 'og:title', content: this.$t('contractors.index.title') },
        { hid: 'og:url', name: 'og:url', content: this.$config.baseUrl + this.localePath({ name: 'contractors-filter', params: { filter: this.$route.params.filter } }) }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: this.breadldjson
        }
      ]
    }
  },

  methods: {
    pageLinkGen (pageNum) {
      const filter = generalMixin.methods.urlGetParams(this.$route.params.filter)
      filter.page = pageNum
      filter.forcePage = true

      return this.localePath({
        name: 'contractors-filter',
        params: {
          filter: generalMixin.methods.urlBuildParams(filter)
        }
      })
    }
  }
}
